import { useState } from "react";
import { colorIsDark } from "../../functions";

export const MonthlyTeamPlanningTimeSlot = (props) => {
    const { timeSlot, selected } = props;
    const aDate1 = new Date(timeSlot.start_date);
    const aDate2 = new Date(timeSlot.end_date);

    const [isHover, setIsHover] = useState(false);

    const handleMouseEnter = () => {
        setIsHover(true);
    };
    const handleMouseLeave = () => {
        setIsHover(false);
    };

    function handleClickTimeSlots(tsId, ctrlKey) {
        props.onClickTimeSlots(tsId, ctrlKey);
    };

    const isReal = timeSlot.state === "REAL";
    const isDarkBg = colorIsDark(timeSlot.hour_type.bg_color);

    const style = {
        cursor: 'pointer',
        backgroundColor: timeSlot.hour_type.bg_color,
        backgroundImage: isReal
            ? "repeating-linear-gradient(45deg, rgba(255,255,255,0.10) 0 1px, rgba(255,255,255,0) 1px 5px)"
            : undefined,
        color: isDarkBg ? '#d0d0d0' : '#0d0d0d',
        border: "2px solid rgba(0, 0, 0, 0.05)",
        borderRadius: "4px",
        height: "100%",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: (selected | isHover) ? '100%' : isReal ? '60%' : '75%',
        boxShadow: isHover ? '1px 2px 9px #1f7d7d' : '',
        borderColor: selected ? "#1f7d7d" : timeSlot.hour_type.bg_color,
        flex: '1',
        overflow: 'hidden',
        textOverflow: 'clip clip',
        whiteSpace: 'nowrap',
        fontStyle: isReal ? 'italic' : 'normal',
    };

    const strStart = aDate1.getHours() + 'h' + (aDate1.getMinutes() > 0 ? ((aDate1.getMinutes() < 10 ? '0' : '') + aDate1.getMinutes()) : '');
    const strEnd = aDate2.getHours() + 'h' + (aDate2.getMinutes() > 0 ? ((aDate2.getMinutes() < 10 ? '0' : '') + aDate2.getMinutes()) : '');

    const title = () => {
        return timeSlot.hour_type.name + "\n" + strStart + " - " + strEnd;
    }

    return (
        <div
            title={title()}
            id={timeSlot.id}
            style={style}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={(e => { e.preventDefault(); handleClickTimeSlots([timeSlot.id], e.ctrlKey) })}
        >
            {timeSlot.hour_type.abbreviation}
        </div>
    );
};
